import { fbt } from 'fbtee'
import { Filter, Heart, Star } from 'lucide-react'
import { OptionChip } from '../../../components/OptionChip'
import type { ScheduleFilter } from './scheduleFilter'
import { GoingCheckIcon } from '../../../components/GoingCheckIcon'

export function FilterButton({
  status,
  onCycle,
  expanded,
}: {
  status: ScheduleFilter
  onCycle: () => void
  /** Show the text label (expanded) or render icon-only (collapsed). */
  expanded?: boolean
}) {
  const label =
    status === 'favorites'
      ? fbt('Favorites', 'Schedule filter chip label when showing only sets favorites are into')
      : status === 'going'
        ? fbt('Going', 'Schedule filter chip label when showing only sets you are going to')
        : status === 'interested'
          ? fbt('Interested', 'Schedule filter chip label when showing sets you are interested in')
          : fbt('Filter', 'Schedule filter chip label when no filter is active')

  const title =
    status === 'favorites'
      ? fbt('Showing only sets your favorites are into. Tap to clear the filter.', 'Tooltip on the schedule filter chip when filter is set to favorites-only')
      : status === 'going'
        ? fbt('Showing only sets you are going to. Tap to change the filter.', 'Tooltip on the schedule filter chip when filter is set to going-only')
        : status === 'interested'
          ? fbt('Showing sets you are interested in. Tap to show only the ones you are going to.', 'Tooltip on the schedule filter chip when filter is set to interested')
          : fbt('Filter the schedule. Tap to show only sets you are interested in.', 'Tooltip on the schedule filter chip when no filter is active')

  const active = status !== 'none'

  // Once a filter is on, the chip shows *which* one — the same status icons the
  // schedule uses — rather than a generic funnel.
  const icon =
    status === 'favorites' ? (
      <Star className="size-5 fill-amber-400 text-amber-400" />
    ) : status === 'going' ? (
      <GoingCheckIcon className="size-5" />
    ) : status === 'interested' ? (
      <Heart className="size-5 fill-interested text-interested" />
    ) : (
      <Filter className="size-5" />
    )

  return (
    <OptionChip
      icon={icon}
      label={label}
      title={title}
      onClick={onCycle}
      active={active}
      showLabel={expanded}
    />
  )
}
